import React from 'react';

import { cn } from 'components/lib/utils';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';

export enum EPricingTabs {
    PRICE_POINTS = 'points',
    SETTINGS = 'settings'
}

interface TabsProps {
    activeTab: EPricingTabs;
    onTabChange: (value: EPricingTabs) => void;
    showSettings: boolean;
}

const TAB_TRIGGER_CLASSES = cn(
    'rounded-none border-b-2 border-transparent bg-transparent px-4 py-3',
    'text-gray-500 font-normal',
    'data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent',
    'data-[state=active]:shadow-none data-[state=active]:text-indigo-600',
    'data-[state=active]:font-semibold'
);

const PricingTabs: React.FC<TabsProps> = ({ activeTab, onTabChange, showSettings }) => {
    const handleChange = (value: string) => {
        onTabChange(value as EPricingTabs);
    };

    return (
        <Tabs value={activeTab} onValueChange={handleChange} className="w-full mb-0">
            <TabsList className="h-auto w-full bg-transparent border-b border-gray-200 rounded-none p-0 justify-start">
                <TabsTrigger value={EPricingTabs.PRICE_POINTS} className={TAB_TRIGGER_CLASSES}>
                    Price Points
                </TabsTrigger>
                {showSettings && (
                    <TabsTrigger value={EPricingTabs.SETTINGS} className={TAB_TRIGGER_CLASSES}>
                        Settings
                    </TabsTrigger>
                )}
            </TabsList>
        </Tabs>
    );
};

export default PricingTabs;

